module.exports = __webpack_public_path__ + "img/theme8.d05c4fa3.png";